import axios from "axios";
import firebase from "firebase";
import router from "../../router";

export default {
  async getIdToken(_) {
    return new Promise((resolve, reject) => {
      firebase.auth().onAuthStateChanged(async (user) => {
        const token = await user.getIdToken();
        resolve(token);
      }),
        (err) => reject(err);
    });
  },

  async refreshToken({ commit }) {
    try {
      const {
        data: {
          data: { user },
        },
      } = await axios.get("auth/refresh");
      const names = user.name.split(" ");
      const initials =
        names.length > 1
          ? `${names[0].charAt(0)}${names[1].charAt(0)}`
          : `${user.name.charAt(0)}${user.name.charAt(1)}`;
      commit("SET_USER", user);
      commit("SET_LOGGED", true);
      commit("SET_INITIALS", initials.toUpperCase());
      return true;
    } catch (err) {
      commit("RESET_STATE");
      router.push({ name: "Login" });
      return err.response?.data || { error: err.message };
    }
  },

  async emailRegister({ dispatch }, { email, password }) {
    try {
      await firebase.auth().createUserWithEmailAndPassword(email, password);
      const { data } = await dispatch("attemptRegistration");
      return data;
    } catch (err) {
      throw err.response?.data || { error: err.message };
    }
  },

  async googleRegister({ dispatch }) {
    try {
      const googleProvider = new firebase.auth.GoogleAuthProvider();
      await firebase.auth().signInWithPopup(googleProvider);
      const { data } = await dispatch("attemptRegistration");
      return data;
    } catch (err) {
      throw err.response?.data || { error: err.message };
    }
  },

  async attemptRegistration({ dispatch }) {
    try {
      const token = await dispatch("getIdToken");
      await axios.post("auth/register", null, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
      return true;
    } catch (err) {
      throw err;
    }
  },

  async completeRegistration({ commit }, newUser) {
    try {
      const {
        data: {
          data: { user },
        },
      } = await axios.post("auth/completeRegistration", newUser);
      const initials = `${user.name.charAt(0)}${user.name.charAt(1)}`;
      commit("SET_USER", user);
      commit("SET_LOGGED", true);
      commit("SET_INITIALS", initials.toUpperCase());
    } catch (err) {
      throw err.response?.data || { error: err.message };
    }
  },

  async emailLogin({ dispatch }, { email, password }) {
    try {
      await firebase.auth().signInWithEmailAndPassword(email, password);
      await dispatch("attemptLogin");
      return true;
    } catch (err) {
      throw err.response?.data || { error: err.message };
    }
  },

  async googleLogin({ dispatch }) {
    try {
      const googleProvider = new firebase.auth.GoogleAuthProvider();
      await firebase.auth().signInWithPopup(googleProvider);
      await dispatch("attemptLogin");
      await dispatch("refreshToken");
      return true;
    } catch (err) {
      throw err.response?.data || { error: err.message };
    }
  },

  async attemptLogin({ commit, dispatch }) {
    try {
      const token = await dispatch("getIdToken");
      const {
        data: {
          data: { user },
        },
      } = await axios.post("auth/login", null, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
      const initials = `${user.name.charAt(0)}${user.name.charAt(1)}`;
      commit("SET_USER", user);
      commit("SET_LOGGED", true);
      commit("SET_INITIALS", initials.toUpperCase());
      return true;
    } catch (err) {
      throw err;
    }
  },

  async logout({ commit }) {
    try {
      await firebase.auth().signOut();
      await axios.get("auth/logout");
      commit("RESET_STATE");
      commit("sensors/RESET_STATE", null, { root: true });
      return true;
    } catch (err) {
      throw err.response?.data || { error: err.message };
    }
  },
};
